import { bridge } from "./bridge.js";
import { BOM } from "./BOM.js";
var util= {
    format:function(param) {
        if (typeof param == "undefined") {
            return "";
        }
        if (typeof param != "object") {
            throw new Error("data sended to the server must be 'object'");
        }
        var s = [];
        for (var j in param) {
            s.push(encodeURIComponent(j) + "=" + encodeURIComponent(param[j]));
        }
        return s.join("&").replace(/%20/g, "+");
    },
    _deFormat:function(param,num_type){
        var p={};
        var temp=param.split("&");
        for(var i= 0,l=temp.length;i<l;i++){
            var t=temp[i].split("=");
            if(t[0]==="extra_data"){
                p[t[0]]=JSON.parse(decodeURIComponent(t[1]));
            }else {
                var num=parseFloat(t[1]);
                //10 作为临界定，为大整数，应该传str
                if(isNaN(num) || t[1].length>10){
                    p[t[0]]=decodeURIComponent(t[1]);
                }else {
                    if(num_type){
                        p[t[0]]=t[1];
                    }else {
                        p[t[0]]=num;
                    }
                }
            }
        }
        return p;
    },
    getUrlStrs:function(href) {
        href = href || window.location.search;
        var data = {}, reg = new RegExp("([^?=&]+)(=([^&]*))?", "g");
        href && href.replace(reg, function ($0, $1, $2, $3) {
            data[$1] = $3;
        });
        return data;
    },
    _getUrlStrs:(function(href) {
        href = href || window.location.search;
        var data = {}, reg = new RegExp("([^?=&]+)(=([^&]*))?", "g");
        href && href.replace(reg, function ($0, $1, $2, $3) {
            data[$1] = $3;
        });
        return data;
    })(),
    countChars:function(str, len, flag) {
        var str=new String(str);
        var strLen = str.replace(/[\uFE30-\uFFA0\u2E80-\u9FFF\u3000\uac00-\ud7ff‘“”’]/g, "**").length, newStr = [], totalCount = 0;
        if (strLen <= len) {
            return str;
        } else {
            for (var i = 0; i < strLen; i++) {
                var nowValue = str.charAt(i);
                if (/[^\x00-\xff]/.test(nowValue)) {
                    totalCount += 2;
                } else {
                    totalCount += 1;
                }
                newStr.push(nowValue);
                if (totalCount >= len) {
                    break;
                }
            }
            if (flag) {
                return newStr.join("");
            } else {
                return newStr.join("") + "...";
            }
        }
    },
    getUniversalParameters:function() {
        var querystring=/.+(\?.+)/.exec(window.location.href);
        if (querystring) {
            querystring = querystring[1];
        } else {
            querystring = "";
        }
        return querystring;
    },
    getCookie:function (c_name) {
        if (document.cookie.length > 0) {
            let c_start = document.cookie.indexOf(c_name + "=");
            if (c_start != -1) {
                c_start = c_start + c_name.length + 1;
                let c_end = document.cookie.indexOf(";", c_start);
                if (c_end == -1) c_end = document.cookie.length;
                return unescape(document.cookie.substring(c_start, c_end));
            }
        }
        return "";
    },
    setCookie:function(name,value,days){
        var Days = days||30;
        var exp = new Date();
        exp.setTime(exp.getTime() + Days*24*60*60*1000);
        document.cookie = name + "="+ escape (value) + ";expires=" + exp.toGMTString();
    },
    isLogin:function(){
        try {
            //兼容安卓
            if(BOM.window.androidObj){
                return util.getCookie("poke_session_id")
            }
            return (BOM.document.pokeUser && BOM.document.pokeUser.uid) || (BOM.window.androidObj && BOM.window.androidObj.pokeUser && JSON.parse(BOM.window.androidObj.pokeUser()).uid);
        }catch (e) {
            return false;
        }
    },
    getPokeUser:function(){
        try {
            return BOM.document.pokeUser || (BOM.document.pokeUser = (BOM.window.androidObj && BOM.window.androidObj.pokeUser && JSON.parse(BOM.window.androidObj.pokeUser())) || {});
        }catch (e) {
            return {};
        }
    },
    getPosition:function(node){
        var posx=0,posy=0;
        while(node.offsetParent) {
            posy = posy + node.offsetTop;
            posx=posx+node.offsetLeft;
            node=node.offsetParent;
        }
        return {
            x:posx,
            y:posy
        };
    },
    isIos:function(){
        if (!navigator) {
            return false;
        }
        if (!navigator.userAgent) {
            return false;
        }
        return /(iPhone|iPad|iPod|iOS)/i.test(navigator.userAgent);
    },
    _toTwoDigit:function(num) { return num < 10 ? "0" + num : num; },
    formatDate: function(time, formation) {
        var date = new Date(time);
        var _temp_year = date.getFullYear();
        var _temp_month = date.getMonth() + 1;
        var _temp_date = date.getDate();
        var _temp_hour = date.getHours();
        var _temp_minute = date.getMinutes();
        var _temp_second = date.getSeconds();
        function _get_date_part(part) {
            switch (part) {
            case "yyyy": return _temp_year;
            case "yy": return _temp_year.toString().slice(-2);
            case "MM": return util._toTwoDigit(_temp_month);
            case "M": return _temp_month;
            case "dd": return util._toTwoDigit(_temp_date);
            case "d": return _temp_date;
            case "HH": return util._toTwoDigit(_temp_hour);
            case "H": return _temp_hour;
            case "hh": return util._toTwoDigit(_temp_hour > 12 ? _temp_hour - 12 : _temp_hour);
            case "h": return _temp_hour > 12 ? _temp_hour - 12 : _temp_hour;
            case "mm": return util._toTwoDigit(_temp_minute);
            case "m": return _temp_minute;
            case "ss": return util._toTwoDigit(_temp_second);
            case "s": return _temp_second;
            default: return part;
            }
        }
        return formation.replace(/y+|m+|d+|h+|s+|H+|M+/g, _get_date_part);
    },
    clientLogin:function(confirmBeforeLogin){
        const params=util._getUrlStrs;
        const _confirmBeforeLogin=confirmBeforeLogin||false;
        if(!params.v){
            window.location.href="https://www.pokekara.com/download";
            return;
        }
        try{
            if(util.isIos()) {
                if(_confirmBeforeLogin){
                    bridge.post('login', {'forward': 'refresh','confirm_before_login':1});
                    return;
                }
                bridge.post('login', {'forward': 'refresh'});
            }else{
                if(_confirmBeforeLogin){
                    BOM.window.androidObj.call("local://login?confirm_before_login=1");
                    return;
                }
                BOM.window.androidObj.call("local://login");
            }

        }catch(e){
            console.log(e);
        }
    },
    shareTwitter:function(shareObj){
        var params=util._getUrlStrs;
        var _shareObj={
            title: shareObj.title||"",
            content: shareObj.content||"",
            url: shareObj.url||"",
            platform:1,
            image_url: shareObj.image_url||""
        };
        if(!util.isIos()){
            _shareObj.android_extra_data=JSON.stringify({name:'webshare'});
        }
        for(var o in shareObj){
            _shareObj[o]=shareObj[o];
        }
        if(params.v&&parseFloat(params.v.replace(".",""))>=10.1) {
            if(!util.isLogin()){
                util.clientLogin();
                return;
            }
            util.openUrl("local://share?"+util.format(_shareObj));
        }else{
            var share_url="https://twitter.com/intent/tweet?text="+encodeURIComponent(_shareObj.title+_shareObj.content)+"&url="+encodeURIComponent(_shareObj.url);
            window.location.href=share_url;
        }
    },
    configShare:function(shareObj){
        //title,content,url,image_url,extra_data,android_extra_data
        var _shareObj={
            //content: shareObj.content||"",
            //url: shareObj.url||""
        };
        for(var o in shareObj){
            _shareObj[o]=shareObj[o];
        }
        _shareObj.extra_data&&(_shareObj.extra_data=_shareObj.android_extra_data);
        util.openUrl("local://config_share?"+util.format(_shareObj));
    },
    showShareView:function(shareObj){
        var _shareObj={
            //content: shareObj.content||"",
            //url: shareObj.url||""
        };
        for(var o in shareObj){
            _shareObj[o]=shareObj[o];
        }
        _shareObj.extra_data&&(_shareObj.extra_data=_shareObj.android_extra_data);
        util.openUrl("local://show_share_view?"+util.format(_shareObj));
    },
    openUrl:function(open_url,num_type){
        var _num_type = num_type || 0;//0 int 1 string
        var params=util._getUrlStrs;
        try {
            if(!params.v){
                window.location.href="https://www.pokekara.com/download";
                return;
            }
            var _hasQueryString=open_url.indexOf("?")!=-1;
            if(params.event_refer_json) {
                if (_hasQueryString) {
                    open_url = open_url + "&event_refer_json=" + params.event_refer_json;
                }else{
                    open_url = open_url + "?event_refer_json=" + params.event_refer_json;
                }
            }
            if (util.isIos()) {
                //var open_url='local://bind?platform=phone'
                var result;
                var re;
                if(!_hasQueryString&!params.event_refer_json){
                    re = new RegExp("\/\/(.+)", "g");
                    if (result = re.exec(open_url)) {
                        bridge.post(result[1]);
                    }
                }else{
                    re = new RegExp("\/\/(.+)\\?([\\s\\S]+)", "g");
                    if (result = re.exec(open_url)) {
                        var p = util._deFormat(result[2],_num_type);
                        bridge.post(result[1], p);
                    }
                }
            } else {
                BOM.window.androidObj.call(open_url);
            }
        }catch(e){
            console.log(e);
        }
    },
    closeWebview(page_ids = []) {
        if (util.isIos()) {
            bridge.post('close', { page_ids });
        } else {
            BOM.window.androidObj.close(JSON.stringify({ page_ids }));
        }
    },
    getStaticData:function(store,page,page_size){
        var length=store.length;
        var _page_size=page_size||10;
        var start=page*_page_size,end=(page+1)*_page_size;
        end=Math.min(end,length);
        start=Math.min(start,length);

        return {
            data:store.slice(start,end),
            has_more:(end!=length)
        };
    },
    translate:function(str,replace_ary){
        var reg=str.match(/%s|%d/g);
        if(reg){
            for(var i=0;i<reg.length;i++){
                str=str.replace(reg[i],replace_ary[i]);
            }
        }
        return str;
    },
    getDeviceSniffSize:function(){
        var ratio = window.devicePixelRatio || 1;
        return {
            width : window.screen.width * ratio,
            height : window.screen.height * ratio
        };
    },
    isScreenLimited:function(params){
        return  this.isIos()?params.screen_height<=480:params.screen_height<=1184;
    },
    isIphonex:(function(){
        var ratio = window.devicePixelRatio || 1;
        var screen = {
            width : window.screen.width * ratio,
            height : window.screen.height * ratio
        };
        return function(){
            return /iphone/gi.test(navigator.userAgent) && (screen.height >= 2436);
        };
    })()(),
    getVersion:function(v){
        var _varray=v.split(".");
        if(_varray.length===2){
            _varray.push("0");
        }
        if(_varray.length!=3){
            return 1000;
        }
        return (+_varray[0]) * 1000 + (+_varray[1]) * 100 + (+_varray[2]);
    },
    getAppVersion:function(v){
        const _v=v || ".";
        const _varray=_v.split(".");
        const l=_varray.length;
        if(l<=1||l>4){
            return 1000000;
        }
        if(l===2){
            _varray.push("0","0");
        }else if(l===3) {
            _varray.push("0");
        }
        return (+_varray[0]) * 1000000 + (+_varray[1]) * 10000 + (+_varray[2])*100+(+_varray[3]);
    },
    trackServer:function(data){
        var _params=util._getUrlStrs;
        var _data={
            event:"",
            label:"",
            value:"",
            extra:"{}"
        };
        for(var o in data){
            _data[o]=data[o];
        }
        _data.extra=JSON.parse(_data.extra);
        try {
            if (_params.event_refer_json) {
                var _extra = JSON.parse(decodeURIComponent(_params.event_refer_json));
                for (var o in _extra) {
                    _data.extra[o] = _extra[o];
                }
            }
            if(util.isIos()) {
                bridge.post("track_server", _data);
            }else{
                _data.extra = JSON.stringify(_data.extra);
                BOM.window.androidObj.call("local://track_server?"+util.format(_data));
            }
        }catch (e) {
            console.log(e);
        }
    },
    trackUmeng:function(data){
        var _data={
            event:"",
            label:""
        };
        for(var o in data){
            _data[o]=data[o];
        }
        try{
            if(util.isIos()) {
                bridge.post("track_umeng", _data);
            }else{
                BOM.window.androidObj.call("local://track_umeng?"+util.format(_data));
            }
        }catch (e) {
            //
        }
    },
    getEnv:function(){
        var _htmlNode=document.getElementsByTagName("html")[0];
        var _env=_htmlNode.getAttribute("env");
        if(_env){
            return _env;
        }
        return "cdn";
    },
    getLang:function(){
        var _htmlNode=document.getElementsByTagName("html")[0];
        var _lang=_htmlNode.getAttribute("lang");
        if(_lang){
            return _lang;
        }
        return "ja";
    },
    openAndriod:function(openUrl,node,tracker){
        //
        var re = new RegExp("universal/(.+)", "g");
        var result;
        if (result = re.exec(openUrl)) {
            openUrl=result[1];
        }
        var url="https://www.pokekara.com/download";
        if(node) {
            var _url = node.getAttribute("href");
            var paramstr=node.getAttribute("param");
            if (_url) {
                url = _url;
            }
            if(paramstr&&tracker){
                var param=new Function("return"+paramstr)();
                tracker.track(param.action);
            }
        }
        window.location.href="pokekara://"+openUrl;
        setTimeout(function(){
            window.location.href= url;
        },2000);
    },
    isUserLogin:function(){
        const env=util.getEnv();
        if(util.isLogin()) return true;
        if(env==="dev"&&util._getUrlStrs.uid){
            return true;
        }
        return false;
    },
    isVersionMoreThanOrEqualTo(v,targetV){
        const currentVersion=this.getAppVersion(v);
        const targetVersion=this.getAppVersion(targetV);
        if(currentVersion>=targetVersion){
            return true;
        }
        return false;
    },
    clientComment:function (p) {
        const param = {
            params: {},
            function_did: function(data, error) {
            },
            function_name: "callback"
        };
        for (let o in  p) {
            param[o] = p[o];
        }
        if (!param.params.hasOwnProperty("comment_type") || !param.params.hasOwnProperty("comment_to")) {
            return false;
        }
        if (util.isIos()) {
            bridge.post('comment', { ...param.params }, param.function_did);
        } else {
            if (typeof androidObj != 'undefined') {
                const _paramStr = this.format(param.params);
                androidObj.call("local://comment?" + _paramStr + "&callback=" + param.function_name);
            } else {
                alert("no androidobject");
            }
        }
        return true;
    },
    getProtocol(env,isWeb){
        const _isWeb=isWeb || false;
        if(!_isWeb) {
            return env === "cdn" ? "https://api.pokekara.com" : "http://test.api.pokekara.com";
        }else {
            return env === "cdn" ? "https://www.pokekara.com" : "http://test.pokekara.com";
        }
    },
    writeKeyChain(keyChain){
        if(window.androidObj){
            androidObj.write_keychain(JSON.stringify(keyChain));
        }else {
            bridge.post("write_keychain",keyChain);
        }
    }
};
function houseWsSend(data,cb){
    if(window.houseWsSend){
        //data 中必须包含func_name 参数
        androidObj.house_ws_send(data);
    }else {
        delete data.func_name;
        bridge.post("house_ws_send",data,(result,error)=>{
            cb(result,error);
        });
    }
}
function getLabelKey(rank) {
    if(rank >100){
        return -1;
    }else  if(rank>50){
        return 5;
    }else if(rank>20){
        return 4;
    }else if(rank>3){
        return 3;
    }else if(rank>2){
        return 2;
    }else if(rank>1){
        return 1;
    }else {
        return 0;
    }
}
function kformat(num) {
    if(num.length){
        num=parseInt(num);
    }
    if(num>1000){
        if(num%1000<10){
            return (num/1000).toFixed(0)+"k";
        }else {
            return (num/1000).toFixed(2)+"k";
        }
    }
    return num;
}
export {
    util,
    houseWsSend,
    getLabelKey,
    kformat
};